module.exports = __webpack_public_path__ + "static/media/creator-background-clouds.68ce6430.jpg";